import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/DependencyTree/NodeLayout/NodeLayout.tsx";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.map.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable react/forbid-component-props */
import React from 'react';
import { useWithDelay } from '@gmini/utils';
import { Tooltip } from '@gmini/ui-kit';
import { NodeLayoutEndContentWrap, NodeLayoutIcons, NodeLayoutRoot, NodeLayoutText, IconLoader, NodeLayoutTextWrap } from "./NodeLayout.styled";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var NodeLayout = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var text = _ref.text,
      icon = _ref.icon,
      checkbox = _ref.checkbox,
      expandJsx = _ref.expandJsx,
      onClick = _ref.onClick,
      onDoubleClick = _ref.onDoubleClick,
      textStyle = _ref.textStyle,
      style = _ref.style,
      endContent = _ref.endContent,
      deepness = _ref.deepness,
      onContextMenu = _ref.onContextMenu,
      _ref$pending = _ref.pending,
      pending = _ref$pending === void 0 ? false : _ref$pending,
      onMouseLeave = _ref.onMouseLeave,
      onMouseOver = _ref.onMouseOver,
      numCycle = _ref.numCycle,
      moreActionButton = _ref.moreActionButton,
      tooltipTitle = _ref.tooltipTitle,
      hover = _ref.hover,
      overLayoutContent = _ref.overLayoutContent;

  var _useWithDelay = useWithDelay({
    hover: hover
  }, {
    enterDelay: 500,
    leaveDelay: 500
  }),
      tooltipOpen = _useWithDelay.hover;

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [overLayoutContent, /*#__PURE__*/_jsxs(NodeLayoutRoot, {
      style: _objectSpread(_objectSpread({}, style), {}, {
        paddingLeft: "".concat(deepness * 18, "px")
      }),
      onClick: onClick,
      onDoubleClick: onDoubleClick,
      onContextMenu: onContextMenu,
      onMouseLeave: onMouseLeave,
      onMouseOver: onMouseOver,
      ref: ref,
      "data-test-type": 'node',
      "data-test-nesting-level": deepness + 1,
      "data-test-id": "showNodeTooltip",
      children: [pending && /*#__PURE__*/_jsx(IconLoader, {
        size: 16
      }), /*#__PURE__*/_jsxs(NodeLayoutIcons, {
        children: [expandJsx, checkbox, icon]
      }), /*#__PURE__*/_jsxs(NodeLayoutTextWrap, {
        children: [/*#__PURE__*/_jsx(Tooltip, {
          placement: "top",
          title: Array.isArray(tooltipTitle) ? tooltipTitle.map(function (row, idx) {
            return (
              /*#__PURE__*/
              // eslint-disable-next-line react/no-array-index-key
              _jsx("div", {
                children: row
              }, idx)
            );
          }) : tooltipTitle || '',
          open: tooltipOpen,
          children: /*#__PURE__*/_jsx(NodeLayoutText, {
            style: textStyle,
            children: text
          })
        }), numCycle]
      }), endContent ? /*#__PURE__*/_jsx(NodeLayoutEndContentWrap, {
        children: endContent
      }) : /*#__PURE__*/_jsx(NodeLayoutEndContentWrap, {
        children: moreActionButton
      })]
    })]
  });
});
NodeLayout.displayName = 'NodeLayout';